<script>
import { InscribeEventsLogger, INSCRIBE_EVENTS } from '@/events-logger';

export default {
  components: {},
  props: {
    document: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      navSelectedItem: 'analysis',
    };
  },
  methods: {
    showSection(name) {
      this.navSelectedItem = name;
      this.$emit('show-section', name);
      InscribeEventsLogger.logEvent(INSCRIBE_EVENTS.DOCUMENT_TABS_CLICKED, {
        itemName: name,
      });
    },
  },
};
</script>

<template>
  <!-- Nav tabs -->
  <div class="document-right-nav d-flex flex-row justify-content-between">
    <button
      :class="{ selected: navSelectedItem === 'analysis' }"
      class="i-text-button-3"
      data-testid="analysis-tab"
      @click="showSection('analysis')"
    >
      Analysis
    </button>
    <button
      :class="{ selected: navSelectedItem === 'details' }"
      class="i-text-button-3"
      data-testid="details-tab"
      @click="showSection('details')"
    >
      Details
    </button>
  </div>
</template>

<style scoped lang="scss">
.document-right-nav {
  button {
    width: 50%;
    height: 40px;
    border-radius: 0;
    border: 0;
    color: $light-neutral-120;
    background-color: $light-neutral-30;

    &.selected {
      background: $white-base;
    }
  }
}
</style>
